import React, { FunctionComponent, ReactNode, useState } from 'react';

import { useUnit } from 'effector-react/ssr';

import { $dialogs, setIsOpenLogin as setIsOpenLoginEvent } from '@stores/dialogs';
import { $loginAction } from '@stores/login-action';
import { getProfileFx } from '@stores/profile';

import { CodeStep, Step, StepKind } from '@utils/login-dialog';
import { SnackBar } from '@utils/snackbar';

import { Dialog } from '@components/common/Dialog/Dialog';

import styles from './LoginDialog.module.scss';

import { LoginDialogCodeForm } from '../LoginDialogCodeForm/LoginDialogCodeForm';
import { LoginDialogLegalLoginForm } from '../LoginDialogLegalLoginForm/LoginDialogLegalLoginForm';
import { LoginDialogPhoneForm } from '../LoginDialogPhoneForm/LoginDialogPhoneForm';

const initialStep: Step = {
    kind: StepKind.Phone,
    phone: '',
    hasAcceptedDataProcessingPolicy: false,
    hasAcceptedUserAgreement: false,
};

export const LoginDialog: FunctionComponent = () => {
    const [{ isOpenLogin }, loginAction, setIsOpenLogin] = useUnit([
        $dialogs,
        $loginAction,
        setIsOpenLoginEvent,
    ]);
    const getProfile = useUnit(getProfileFx);

    const [step, setStep] = useState<Step>(initialStep);

    const handleLoginSuccess = () => {
        getProfile()
            .then(() => {
                setIsOpenLogin(false);
                setStep(initialStep);
                SnackBar.success('Вы успешно вошли в аккаунт');

                if (loginAction.effect !== null) {
                    loginAction.effect();
                }
            })
            .catch((error) => {
                SnackBar.handleApiError(error);
            });
    };

    let title: string;
    let goBack: (() => void) | undefined;
    let content: ReactNode;

    switch (step.kind) {
        case StepKind.Phone:
            title = 'Вход / Регистрация';
            goBack = undefined;
            content = <LoginDialogPhoneForm step={step} setStep={setStep} />;
            break;
        case StepKind.Code:
            title = 'Введите код';
            goBack = () => {
                setStep({
                    kind: StepKind.Phone,
                    phone: step.phone,
                    hasAcceptedDataProcessingPolicy: step.hasAcceptedDataProcessingPolicy,
                    hasAcceptedUserAgreement: step.hasAcceptedUserAgreement,
                });
            };
            content = (
                <LoginDialogCodeForm
                    step={step as CodeStep}
                    setStep={setStep}
                    onSuccess={handleLoginSuccess}
                />
            );
            break;
        case StepKind.Legal:
            title = 'Войти как юр. лицо';
            goBack = () => {
                setStep(initialStep);
            };
            content = <LoginDialogLegalLoginForm onSuccess={handleLoginSuccess} />;
            break;
    }

    return (
        <Dialog
            isOpen={isOpenLogin}
            setOpen={setIsOpenLogin}
            title={title}
            onGoBack={goBack}
            classes={{ content: styles.dialogContent }}
        >
            <div className={styles.root}>{content}</div>
        </Dialog>
    );
};
